import React, { useContext } from "react";
import MenuUsa from "../components/commons/menuUsa";
import MainBanner from "../components/home/banner";
import ServicesUsa from "../components/home/ourServicesUsa";
import { LocationAddress } from "../components/usa/locationAddress";
import WhatMoves from "../components/home/whatMoves";
import Partners from "../components/home/ourPartners";
import CareerJoinUs from "../components/home/careerJoinUs";
import { Footer } from "../components/commons/footer";
import { DownloadBanner } from "../components/commons/downloadBanner";
import Awards from "../components/commons/Awards";
import { ContentHomeContext } from "../contexts/ContentHomeContext";
import SEOContent from "../components/commons/SEOContent";
import { MSSeparatorContainer } from "../components/commons/MSSeparator";

export const HomeUsa = () => {
  const { SEOContent: SEOData } = useContext(ContentHomeContext);
  return (
    <>
      <SEOContent SEOData={SEOData} />
      <MenuUsa />
      <MainBanner />
      <MSSeparatorContainer />
      <ServicesUsa />
      <WhatMoves />
      <Partners />
      <Awards />
      <DownloadBanner />
      <CareerJoinUs />
      <LocationAddress />
      <Footer />
    </>
  );
};
